import React from 'react';
import { HelpProvider } from '../../contexts/HelpContext';
import HelpFloatingButton from './HelpFloatingButton';
import HelpDrawer from './HelpDrawer';
import { useAuth } from '../../contexts/AuthContext';

const HelpSystem = ({ children }) => {
  const { user } = useAuth();

  return (
    <HelpProvider>
      {children}
      {user && <HelpFloatingButton />}
      {user && <HelpDrawer />}
    </HelpProvider>
  );
};

export default HelpSystem;
